/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import {
  EmailInput,
  TextInput,
  PhoneNumberInput,
  PasswordInput,
} from './components';
import './styles.css';
import toast from 'react-hot-toast';

export interface IFormCompProps {
  fields?: any;
  initialData?: any;
  isPasswordField?: boolean;
  submitButtonLabel?: string;
  onFormSubmit?(payload: any): void;
  renderSubmitButton?(): void;
  labelColor?: string;
}

export const FormComp = (props: IFormCompProps) => {
  const {
    isPasswordField,
    fields,
    initialData,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
  } = props;
  const [formData, updateFormData] = useState<any>(initialData ?? {});
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [passwordErr, setPasswordErr] = useState<any>(false);

  const _renderSubmitButton = () => {
    if (renderSubmitButton) {
      return renderSubmitButton();
    }
    return (
      <div className="mt-3">
        <Button
          variant="secondary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '50%',
            borderRadius: '0px',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {submitButtonLabel}
        </Button>
      </div>
    );
  };

  const handleSubmit = (e?: any) => {
    const form = e.currentTarget;
    const isValid = form.checkValidity();
    e.preventDefault();
    e.stopPropagation();
    let hasError = false;
    const errorsObj: any = {};
    // let _fields = [];
    // _fields = fields;

    if (
      (fields?.phoneNumber?.required && !formData[fields?.phoneNumber?.id]) ||
      formData[fields?.phoneNumber?.id].length < 8
    ) {
      errorsObj[fields.phoneNumber.id] = true;
      hasError = true;
    }
    if (isPasswordField && formData[fields?.password?.id] !== undefined) {
      const regex =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\-]).{8,}$/;

      if (regex.test(formData[fields?.password?.id])) {
        console.log('Password matches the regex pattern.');
      } else {
        console.log('Password does not match the regex pattern.');
        setPasswordErr(true);
        errorsObj[fields?.password?.id] = true;
        hasError = true;
      }
    }
    if (
      isPasswordField &&
      formData[fields?.password?.id] &&
      formData[fields?.confirmPassword?.id]
    ) {
      if (formData[fields?.password?.id].length < 8) {
        console.log('password length < 8');
        errorsObj[fields.password.id] = true;
        hasError = true;
      }
      if (
        formData[fields?.password?.id] !== formData[fields?.confirmPassword?.id]
      ) {
        console.log('password and confirm password does not match');
        errorsObj[fields.confirmPassword.id] = true;
        hasError = true;
      }
    }

    setValidated(true);
    if (!hasError && isValid) {
      setErrors({});
      onFormSubmit && onFormSubmit(formData);
    } else {
      window?.scrollTo(0, 0);
      setErrors(errorsObj);
    }
  };
  const handleCompChange = (id: string, payload: any) => {
    if (id && payload && errors[id]) {
      delete errors[id];
    }
    updateFormData({
      ...formData,
      [id]: payload,
    });
  };
  const _renderLayout = () => {
    console.log('_renderLayout initialData', initialData);
    return (
      <Row key={`layout-1-row-default-layout`}>
        <Col key={`layout-1-columns-email`} sm={12} className="mb-3">
          <EmailInput
            {...fields?.email}
            value={initialData?.email}
            labelColor={'#000'}
            onCompChange={handleCompChange}
          />
        </Col>
        <Col key={`layout-1-columns-firstName`} sm={6} xs={12} className="mb-3">
          <TextInput
            {...fields?.firstName}
            value={initialData?.firstName}
            onCompChange={handleCompChange}
            hasError={!!errors[fields?.firstName?.id]}
          />
        </Col>
        <Col key={`layout-1-columns-lastName`} sm={6} xs={12} className="mb-3">
          <TextInput
            {...fields?.lastName}
            value={initialData?.lastName}
            onCompChange={handleCompChange}
            hasError={!!errors[fields?.lastName?.id]}
          />
        </Col>
        <Col key={`layout-1-columns-phoneNumber`} sm={12} className="mb-3">
          <PhoneNumberInput
            {...fields?.phoneNumber}
            value={initialData?.phoneNumber}
            onCompChange={handleCompChange}
            hasError={!!errors[fields?.phoneNumber?.id]}
            // errorText={errors[fields?.phoneNumber?.id]}
          />
        </Col>
        {isPasswordField && (
          <>
            <Col key={`layout-1-columns-password`} sm={12} className="mb-3">
              <PasswordInput
                {...fields?.password}
                value={initialData?.password}
                onCompChange={handleCompChange}
                hasError={!!errors[fields?.password?.id]}
                errorText={
                  errors[fields?.password?.id] === true
                    ? passwordErr
                      ? fields?.password?.errorText1
                      : fields?.password?.errorText
                    : fields?.password?.errorText
                }
              />
            </Col>
            <Col
              key={`layout-1-columns-confirm-password`}
              sm={12}
              className="mb-3"
            >
              <PasswordInput
                {...fields?.confirmPassword}
                value={initialData?.confirmPassword}
                onCompChange={handleCompChange}
                hasError={!!errors[fields?.confirmPassword?.id]}
                errorText={
                  errors[fields?.confirmPassword?.id] === true
                    ? 'Your password and confirmation password must match'
                    : fields?.confirmPassword?.errorText
                }
              />
            </Col>
          </>
        )}
      </Row>
    );
  };
  return (
    <>
      <Form
        noValidate
        validated={validated}
        className="mt-4"
        onSubmit={handleSubmit}
      >
        <>
          {_renderLayout()}
          {/*{_renderFormGroup()}*/}
          {_renderSubmitButton()}
        </>
      </Form>
    </>
  );
};

FormComp.defaultProps = {
  isPasswordField: false,
  fields: {
    email: {
      id: 'email',
      label: 'Email',
      required: true,
      placeholder: 'Enter your email address',
      errorText: 'Email is required',
      readOnly: true,
    },
    firstName: {
      id: 'firstName',
      label: 'First Name',
      required: true,
      placeholder: 'Enter your name',
      errorText: 'First Name is required',
    },
    lastName: {
      id: 'lastName',
      label: 'Last Name',
      required: true,
      placeholder: 'Enter your last name',
      errorText: 'Last Name is required',
    },
    phoneNumber: {
      id: 'phoneNumber',
      label: 'Mobile Number',
      required: true,
      placeholder:
        'Select your country code first and then Enter mobile Number',
      errorText:
        'Mobile number is required and Minimum length of Phone Number should be 8',
    },
    password: {
      id: 'password',
      label: 'Password',
      required: true,
      errorText: 'Password is required',
      pattern: `/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\-]).{8,}$/`,
      errorText1:
        'Password should contain min 8 characters,1 upper case,1 lower case, 1 number and 1 special character ',
      placeholder: 'Enter password',
    },
    confirmPassword: {
      id: 'confirmPassword',
      label: 'Confirm Password',
      required: true,
      errorText: 'Confirm Password is required',
      placeholder: 'Password should be atleast 8 characters long',
    },
  },
};
